import {actionTypes} from "./type";
import {BaseReducer} from "../../reducers/base";

const types = actionTypes;

const initialState = {
    datas: [],
    data: {},
    isLoading: false,
    success: false,
    msg: {},
};

const actionReducer = (state = initialState, action) => {
    const baseClass = new BaseReducer(types, state, action);

    return baseClass.baseReducer();
};

export default actionReducer;
